module.exports = __webpack_public_path__ + "4b92f9961f25413b9889b081cafa5a39.gif";